import LoadMoreList from '../PracticeList'
import {connect} from 'react-redux'


function mapReduxDispatchToReactProps(dispatch){
    return {
        onClick: function(size){
            dispatch({type: 'INCREMENT', size:size})
        }
    }

}
export default connect(null, mapReduxDispatchToReactProps)(LoadMoreList)

// import React, {Component } from 'react';
// import store from '../store';


// export default class extends Component{
//     render(){
//         return (
//             <div>
//                 <p> AddNumber Container</p>
//                 <LoadMoreList onClick ={
//                     function(size) {
//                         store.dispatch({type:'INCREMENT', size:size})
//                     }.bind(this)
//                 }></LoadMoreList>
//             </div>
//         )
//     }
// }